<template>
  <div>
    <span v-if="isEdditing" v-on-clickaway="cancel">
      <form class="form-inline" @submit.prevent="save">
        <div class="input-group">
          <input type="number" step="any" min="0" class="form-control" v-model="newSalePrice" style="width: 80px;">
          <span class="input-group-btn">
            <button type="submit" class="btn btn-success btn-noborder">
              <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
              <i class="fa fa-check" v-else></i>
            </button>
          </span>
        </div>
      </form>
    </span>

    <span @click="edit" v-else>
      <span class="editable text-primary" v-if="productPrice && salePrice">  <small><del>€ {{productPrice}}</del></small> € {{salePrice}}</span>
      <span class="editable text-danger" v-else><i>n.n.b.</i></span>
    </span>

    <text-alert :alert.sync="alert"></text-alert>
  </div>
</template>

<script>
import http from '../utils/http'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  mixins: [clickaway],
  props: ['price', 'sale_price', 'productId'],
  data () {
    return {
      productPrice: this.price,
      newSalePrice: this.sale_price,
      salePrice: this.sale_price,
      isEdditing: false,
      isLoading: false,
      alert: false
    }
  },
  created () {
    this.$root.$on('product-price-updated', this.onUpdate)
  },
  destroy () {
    this.$root.$off('product-price-updated', this.onUpdate)
  },
  methods: {
    edit () {
      this.isEdditing = true
      this.newSalePrice = this.salePrice
    },
    cancel () {
      this.isEdditing = false
    },
    save () {
      this.isLoading = true

      if (parseInt(this.newSalePrice) === 0 || !this.newSalePrice) {
        this.newSalePrice = null
      }

      const data = {
        sale_price: this.newSalePrice
      }

      return http.patch(`/products/${this.productId}`, data)
        .then((response) => {
          this.salePrice = this.newSalePrice
          this.isEdditing = false
          this.isLoading = false

          this.alert = { variant: 'success', message: 'Opgeslagen' }

          this.$root.$emit('product-sale_price-updated', {
            product_id: this.productId,
            sale_price: this.newSalePrice
          })
        })
        .catch(() => {
          this.isLoading = false
          this.alert = { variant: 'danger', message: 'Er is iets fout gegaan' }
        })
    },
    onUpdate (e) {
      if (this.productId === e.product_id) {
        this.salePrice = e.quantity
        this.newSalePrice = e.quantity
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SalePriceEditable.vue?424581ff